"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _popupStateful = _interopRequireDefault(require("../Popup/popupStateful"));

var _typography = require("../Typography/typography");

var _link = _interopRequireDefault(require("../Link/link"));

var _chip = _interopRequireDefault(require("../Chip/chip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChipsPopup = function ChipsPopup(_ref) {
  var children = _ref.children,
      remainingChipsCount = _ref.remainingChipsCount,
      remainderElementSize = _ref.remainderElementSize,
      position = _ref.position,
      popupHeaderTitle = _ref.popupHeaderTitle;
  var headerText = typeof popupHeaderTitle === 'string' ? popupHeaderTitle : popupHeaderTitle(children.length);
  return _react.default.createElement(_popupStateful.default.Wrapper, null, _react.default.createElement(_popupStateful.default, {
    position: position,
    target: _react.default.createElement(_link.default, null, _react.default.createElement(_chip.default, {
      alternate: true,
      info: true,
      small: remainderElementSize === 'small',
      large: remainderElementSize === 'large'
    }, "+".concat(remainingChipsCount)))
  }, _react.default.createElement(_popupStateful.default.Header, null, _react.default.createElement(_typography.H5, null, headerText)), _react.default.createElement(_popupStateful.default.Content, null, children)));
};

var defaultPopupHeaderTitle = function defaultPopupHeaderTitle(chipsNumbers) {
  return "".concat(chipsNumbers, " ").concat(chipsNumbers > 1 ? 'tags' : 'tag');
};

ChipsPopup.defaultProps = {
  position: _popupStateful.default.POSITION_LEFT_BOTTOM,
  popupHeaderTitle: defaultPopupHeaderTitle
};
var _default = ChipsPopup;
exports.default = _default;
ChipsPopup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ChipsPopup",
  "props": {
    "position": {
      "defaultValue": {
        "value": "PopupStateful.POSITION_LEFT_BOTTOM",
        "computed": true
      },
      "required": false
    },
    "popupHeaderTitle": {
      "defaultValue": {
        "value": "(chipsNumbers) => `${chipsNumbers} ${chipsNumbers > 1 ? 'tags' : 'tag'}`",
        "computed": false
      },
      "required": false
    }
  }
};